// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//  export const environment = {
//   production: false,
//   baseURL: {
//     base: "https://itsdev.cspinnova.com",
//     login: "https://itsdev.cspinnova.com/api-test/login",
//     users: "https://itsdev.cspinnova.com/api-test/users",
//     current_user: "https://itsdev.cspinnova.com/api-test/users/current",
//     workout_programs: "https://itsdev.cspinnova.com/api-test/workout-programs",
//     equipments: "https://itsdev.cspinnova.com/api-test/equipments",
//     workouts: "https://itsdev.cspinnova.com/api-test/workouts",
//     exercises: "https://itsdev.cspinnova.com/api-test/exercises",
//     workout_phase_types: 'https://itsdev.cspinnova.com/api-test/workout-phase-types',
//     user_workout_programs: 'https://itsdev.cspinnova.com/api-test/user-workout-programs',
//     user_notification_status: 'https://itsdev.cspinnova.com/api-test/user-notification-status',
//     subscriptions: 'https://itsdev.cspinnova.com/api-test/subscriptions',
//     challenges: 'https://itsdev.cspinnova.com/api-test/challenges',
//     nutrition_survey: 'https://itsdev.cspinnova.com/api-test/nutrition-survey',
//     help: 'https://itsdev.cspinnova.com/api-test/help',
//     fe: 'https://itsdev.cspinnova.com/',
//     video: 'https://itsdev.cspinnova.com/v1d',
//     pdf: '',
//     register: "https://itsdev.cspinnova.com/api-test/register",
//     notifications: "https://itsdev.cspinnova.com/api-test/notifications",
//     chargebee:"https://itsdev.cspinnova.com/api-test/chargebee",
//     category: 'https://itsdev.cspinnova.com/api-test/category',
//     mock: 'https://659e6d5a47ae28b0bd35cf35.mockapi.io/getstronger',
//     promotions: 'https://itsdev.cspinnova.com/api-test/promotions',
//     util:"https://659e6d5a47ae28b0bd35cf35.mockapi.io/getstronger/util/fg43lk7df29aq1mh3lk7df29aq",
//     node: "https://itsdev.cspinnova.com/napi/api"
//   }
// };

export const environment = {
  production: false,
  baseURL: {
    base: "https://app.itsdesifit.com",
    login: "https://app.itsdesifit.com/api/login",
    users: "https://app.itsdesifit.com/api/users",
    register: "https://app.itsdesifit.com/api/register",
    current_user: "https://app.itsdesifit.com/api/users/current",
    exercises_search: "https://app.itsdesifit.com/api/exercises/search",
    exercises: "https://app.itsdesifit.com/api/exercises",
    exercise_type: "https://app.itsdesifit.com/api/bos/exercise-type",
    exercise_muscle: "https://app.itsdesifit.com/api/bos/muscle-group",
    exercise_training: "https://app.itsdesifit.com/api/bos/training-group",
    workouts_search: "https://app.itsdesifit.com/api/workouts/search",
    workouts: "https://app.itsdesifit.com/api/workouts",
    equipments: "https://app.itsdesifit.com/api/equipments/search",
    equipment: "https://app.itsdesifit.com/api/equipments",
    workout_programs: "https://app.itsdesifit.com/api/workout-programs",
    user_workout_programs: 'https://app.itsdesifit.com/api/user-workout-programs',
    workout_phase_types: 'https://app.itsdesifit.com/api/workout-phase-types',
    promotions: 'https://app.itsdesifit.com/api/promotions',
    subscriptions: 'https://app.itsdesifit.com/api/subscriptions',
    bos: 'https://app.itsdesifit.com/api/bos',
    notifications: 'https://app.itsdesifit.com/api/notifications',
    user_notification_status: 'https://app.itsdesifit.com/api/user-notification-status',
    challenges: 'https://app.itsdesifit.com/api/challenges',
    nutrition_survey: 'https://app.itsdesifit.com/api/nutrition-survey',
    diet: 'https://app.itsdesifit.com/api/diet',
    nutritionists: 'https://app.itsdesifit.com/api/nutritionists',
    stripe: 'https://app.itsdesifit.com/api/stripe',
    paypal: 'https://app.itsdesifit.com/api/paypal',
    chargebee: 'https://app.itsdesifit.com/api/chargebee',
    video: 'https://app.itsdesifit.com/v1d',
    report: 'https://app.itsdesifit.com/api/report',
    script_paypal: 'https://www.paypal.com/sdk/js?client-id=AWPNATW4tHZtxz0UR_RqH4fiD9rAmP2aPfaJemOtyuNp1M6MXi07C1czdE_Qo0dKEj0z_dZ6ze4ukLDo&amp;components=buttons&amp;vault=true',
    mock: 'https://659e6d5a47ae28b0bd35cf35.mockapi.io/getstronger',
    category: 'https://app.itsdesifit.com/api/category',
    util:"https://659e6d5a47ae28b0bd35cf35.mockapi.io/getstronger/util/fg43lk7df29aq1mh3lk7df29aq",
    node: "https://app.itsdesifit.com/napi/api"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
